import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack, Text, useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteLicense } from "../../../../api";
import { colors } from "../../../../styles";
import { getSignUpErrorMessage } from "../../../Auth/SignUp/errors";

interface DeleteLicenseModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function DeleteLicenseModal({ isOpen, onClose }: DeleteLicenseModalProps) {
    const queryClient = useQueryClient();
    const toast = useToast();

    const deleteLicenseMutation = useMutation({
        mutationFn: deleteLicense,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["me"] });
            toast({
                title: "약사 면허 삭제에 성공했습니다.",
                status: "success",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
            onClose();
        },
        onError: (error) => {
            toast({
                title: getSignUpErrorMessage(error, "약사 면허 삭제에 실패했습니다."),
                status: "error",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    return (
        <Modal motionPreset="slideInBottom" isOpen={isOpen} onClose={onClose} size="xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text fontSize={20} fontWeight={700} color={colors.black}>약사 면허 삭제하기</Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody padding={5}>
                    <Text fontSize={16} fontWeight={400} color={colors.black}>
                        약사 면허 정보를 삭제하시겠습니까?<br />
                        삭제 후 약사 면허 정보는 복구할 수 없습니다.
                    </Text>
                    <Text fontSize={14} fontWeight={700} color={colors.link} marginY={5}>
                        *삭제 후 가입 유형이 변경될 수 있습니다.
                    </Text>
                    <Stack marginTop={5} width="100%">
                        <Button
                            onClick={() => deleteLicenseMutation.mutate()}
                            isLoading={deleteLicenseMutation.isPending}
                            width="100%"
                            backgroundColor={colors.black}
                            color={colors.white}
                        >
                            삭제
                        </Button>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
